import { render, staticRenderFns } from "./BaxNumbers.vue?vue&type=template&id=528b7a5c&"
import script from "./BaxNumbers.vue?vue&type=script&lang=ts&"
export * from "./BaxNumbers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports